import * as React from 'react';
import { IgcActionStripComponent as Component } from 'igniteui-webcomponents-grids/grids/index.js';
import { createComponent } from '../react-props.js';

/**
 * Action Strip provides templatable area for one or more actions.
 * @class
 */
export const IgrActionStrip = /* @__PURE__ */ createComponent({
  tagName: 'igc-action-strip',
  displayName: 'IgrActionStrip',
  elementClass: Component,
  react: React,
  moveBackOnDelete: true,
});

export type IgrActionStrip = Component;

/** @deprecated Module register is no longer needed and can be removed */
export const IgrActionStripModule = Component;
